function UnifiedTreeView({ data, searchTerm = '', config = {} }) {
  const {
    getNodeId = (id) => id,
    getNodeData = (data) => data,
    getDescription = (data) => data.description || data.notes || '',
    getMetadata = (data) => null,
    getChildren = (data) => data.children || null
  } = config;

  const renderNode = (nodeId, nodeData, level = 0, isLast = false, parentPrefix = '') => {
    const description = getDescription(nodeData);
    const metadata = getMetadata(nodeData);
    const children = getChildren(nodeData);
    
    // Build tree connector for current node
    let connector = '';
    if (level === 0) {
      connector = '';
    } else {
      connector = isLast ? '└─ ' : '├─ ';
    }
    
    // Search filter
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      const matches = nodeId.toLowerCase().includes(searchLower) ||
                    description.toLowerCase().includes(searchLower);
      if (!matches && !children) return null;
    }
    
    // Render current node
    const hasChildren = children && Object.keys(children).length > 0;
    const nodeElement = (
      <div key={`${level}-${nodeId}`} className={hasChildren ? 'tree-parent' : ''}>
        <div className="tree-item">
          <div className="tree-line">
            <span className="tree-connector">
              {parentPrefix}{connector}
            </span>
            <span className="tree-node-id">{nodeId}</span>
            {metadata && (
              <span className="tree-metadata">
                {metadata}
              </span>
            )}
            <span className="tree-description">{description}</span>
          </div>
        </div>
        
        {hasChildren && (
          <div>
            {Object.entries(children).map(([childId, childData], idx, arr) => {
              const isLastChild = idx === arr.length - 1;
              const childPrefix = level === 0 
                ? '' 
                : parentPrefix + (isLast ? '    ' : '│   ');
              return renderNode(childId, childData, level + 1, isLastChild, childPrefix);
            })}
          </div>
        )}
      </div>
    );
    
    return nodeElement;
  };

  // Handle different data structures
  let nodesToRender = [];
  
  if (Array.isArray(data)) {
    nodesToRender = data.map((item, idx) => ({
      id: item.id,
      data: item,
      isLast: idx === data.length - 1
    }));
  } else if (data.nodes) {
    const entries = Object.entries(data.nodes);
    nodesToRender = entries.map(([id, nodeData], idx) => ({
      id: id,
      data: nodeData,
      isLast: idx === entries.length - 1
    }));
  } else {
    return <div className="empty-state"><p>No data available</p></div>;
  }

  return (
    <div className="tree-view">
      {nodesToRender.map(({ id, data: nodeData, isLast }) => 
        renderNode(id, nodeData, 0, isLast, '')
      )}
    </div>
  );
}

export default UnifiedTreeView;
